import { type RtkQueryLayers } from '../../core';
import { subscriptions } from './subscriptions.og';

export const subscriptionsRTKSlice: RtkQueryLayers = {
  reducers: {
    [subscriptions.reducerPath]: subscriptions.reducer,
  },
  middlewares: [subscriptions.middleware],
};
